import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { Link as DSRLink, Optional } from '@honda-canada/design-system-react';
import { compiler } from 'markdown-to-jsx';
import { stripMarkdownHeading } from '../../../utils/markdown';
import RoutableSitecoreLink from '../../RoutableSitecoreLink';

import FooterContext from '../service/FooterContext';
import ContactInfo from './ContactInfo';
import themeStyles from '../Footer.styles';
import { ITEM_TYPE_CONTACT, ITEM_TYPE_URL } from '../../../utils/constants';
import { getAnchorAttributes, getFooterGtmTags } from '../utils';
import formatDataTestId from '../../../utils/formatDataTestId';

const ItemLink = themeStyles.apply(DSRLink, 'ItemLink');

const WebLink = ({ linkUrl, displayName, gtmParent }) => {
  const { styles } = useContext(FooterContext);
  const anchorAttributes = getAnchorAttributes(linkUrl);
  const label = linkUrl?.text;
  return (
    <ItemLink
      data-testid={`cy-footer-link-item${formatDataTestId(label)}`}
      as={RoutableSitecoreLink}
      field={anchorAttributes}
      ariaLabel={label}
      tabIndex={0}
      {...getFooterGtmTags(displayName, gtmParent)}
      {...styles.itemLink}
    >
      {compiler(stripMarkdownHeading(label), {
        namedCodesToUnicode: {
          copy: '\u00A9',
        },
      })}
    </ItemLink>
  );
};

const LinkItem = ({ item, gtmParent }) => {
  const linkType = item?.label !== undefined ? ITEM_TYPE_CONTACT : ITEM_TYPE_URL;

  return (
    <>
      <Optional when={linkType === ITEM_TYPE_URL}>
        <WebLink linkUrl={item?.url} displayName={item?.displayName} gtmParent={gtmParent} />
      </Optional>
      <Optional when={linkType === ITEM_TYPE_CONTACT}>
        <ContactInfo item={item} />
      </Optional>
    </>
  );
};

LinkItem.propTypes = {
  item: PropTypes.shape({
    url: PropTypes.shape({
      href: PropTypes.string,
      text: PropTypes.string,
    }),
    label: PropTypes.string,
    displayName: PropTypes.string,
  }),
};

export default LinkItem;
